import { useState } from "react";
import { toast } from "sonner";
import { api, BUYER_TYPES } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const empty = { name: "", company: "", email: "", phone: "", buyer_type: "", message: "" };

export const InquiryForm = ({ type = "contact", items = [], onSuccess, submitLabel = "Send inquiry", testPrefix = "inquiry", showBuyerType = true, messagePlaceholder }) => {
  const { user } = useAuth();
  const [f, setF] = useState({ ...empty, name: user?.name || "", email: user?.email || "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!f.name || !f.email) return toast.error("Name and email are required");
    setBusy(true);
    try {
      const { data } = await api.post("/inquiries", { ...f, type, items: items.map((i) => ({ product_id: i.product_id, quantity: i.quantity })) });
      toast.success(`Received — reference ${data.inquiry_id}. We'll be in touch shortly.`);
      setF({ ...empty, name: user?.name || "", email: user?.email || "" });
      onSuccess?.(data);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Could not submit. Please try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} className="grid gap-4 sm:grid-cols-2" data-testid={`${testPrefix}-form`}>
      <input className="sr-input" placeholder="Full name *" value={f.name} onChange={set("name")} data-testid={`${testPrefix}-name-input`} required />
      <input className="sr-input" placeholder="Company / Store" value={f.company} onChange={set("company")} data-testid={`${testPrefix}-company-input`} />
      <input className="sr-input" type="email" placeholder="Work email *" value={f.email} onChange={set("email")} data-testid={`${testPrefix}-email-input`} required />
      <input className="sr-input" placeholder="Phone" value={f.phone} onChange={set("phone")} data-testid={`${testPrefix}-phone-input`} />
      {showBuyerType && (
        <select className="sr-input sm:col-span-2" value={f.buyer_type} onChange={set("buyer_type")} data-testid={`${testPrefix}-buyer-type-select`}>
          <option value="">Buyer type…</option>
          {BUYER_TYPES.map((b) => <option key={b} value={b}>{b}</option>)}
        </select>
      )}
      <textarea className="sr-input sm:col-span-2 min-h-[110px]" placeholder={messagePlaceholder || "Tell us about your category needs, target channels and volume requirements."} value={f.message} onChange={set("message")} data-testid={`${testPrefix}-message-input`} />
      <button type="submit" disabled={busy} className="sr-btn-blue sm:col-span-2 justify-center disabled:opacity-60" data-testid={`${testPrefix}-submit-button`}>
        {busy ? "Sending…" : submitLabel}
      </button>
    </form>
  );
};
